/* eslint-disable */
import { useContext, useEffect } from 'react'
import axios from 'axios'
import Cookies from 'js-cookie'
import { useNavigate } from 'react-router-dom'
import { APP_CONFIG, AWS_CONFIG } from '../../config'
import {
  AuthContext,
  redirectToLogin,
  redirectToLogout,
} from '../../Auth'
import IsSearchingCircle from '../InvestigationPage/IsSearchingCircle'
import { PLATFORM_AWS, PLATFORM_AZURE } from '../../utils/platform'
import * as azureAuth from '../../services/azureAuth'

export default function Auth() {
  const query = new URLSearchParams(window.location.search)
  const code = query.get('code') || ''
  const navigate = useNavigate()
  const { setAuth } = useContext(AuthContext)

  useEffect(() => {
    if (APP_CONFIG.Platform === PLATFORM_AZURE) {
      const handleAzureCallback = async () => {
        try {
          const idToken = await azureAuth.handleCallback()
          Cookies.set('auth_token', idToken)
          setAuth(true)
          navigate('/')
        } catch (error: any) {
          console.error('Azure callback error:', error)
          // On error, redirect to logout
          // navigate('/logout')
          // location.reload()
        }
      }

      handleAzureCallback()
    } else {
      if (APP_CONFIG.Platform === PLATFORM_AWS) {
        const params = new URLSearchParams()
        params.append('grant_type', 'authorization_code')
        params.append('client_id', AWS_CONFIG.ClientId)
        params.append('code', code)
        params.append('redirect_uri', AWS_CONFIG.LoginRedirectUri)

        axios
          .post(`https://${AWS_CONFIG.CognitoDomain}/oauth2/token`, params, {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          })
          .then((response) => {
            const idToken = response.data.id_token
            Cookies.set('auth_token', response.data.id_token)
            setAuth(true)
            navigate('/')
          })
          .catch((error) => {
            console.error(error)
          })
      } else {
        navigate('/login')
      }
    }
  }, [code, navigate, setAuth])

  return <IsSearchingCircle />
}
